export default "__VITE_ASSET__BAMk3r84__"